/** Time units, so a duration reads as one instead of a product of bare numbers. */
export const MINUTES_PER_DAY = 1440,
  MS_PER_DAY = 86_400_000,
  MS_PER_HOUR = 3_600_000,
  MS_PER_MINUTE = 60_000,
  MS_PER_SECOND = 1000,
  MS_PER_WEEK = 604_800_000,
  SECONDS_PER_DAY = 86_400,
  SECONDS_PER_HOUR = 3600,
  SECONDS_PER_MINUTE = 60;
